import { render, staticRenderFns } from "./ChecklistItemTable.vue?vue&type=template&id=c8463da6&scoped=true"
import script from "./ChecklistItemTable.vue?vue&type=script&lang=js"
export * from "./ChecklistItemTable.vue?vue&type=script&lang=js"
import style0 from "./ChecklistItemTable.vue?vue&type=style&index=0&id=c8463da6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8463da6",
  null
  
)

export default component.exports